import Vue from 'vue';

export default {
  state: {
    subStatuses: [],
  },
  getters: {
    customerSubStatuses(state) {
      return state.subStatuses.filter(item => item.propagate);
    },
    subStatuses(state) {
      return state.subStatuses;
    },
    getSubStatusesByStatus: state => id => (
      state.subStatuses.filter(item => item.status_id === id) || []
    ),
    subStatus: state => id => (
      state.subStatuses.find(item => item.id === id) || {}
    ),
  },
  mutations: {
    SET_SUB_STATUSES(state, payload) {
      state.subStatuses = payload;
    },
  },
  actions: {
    GET_SUB_STATUSES(context) {
      return Vue.axios.get('filters/sub_statuses').then((response) => {
        context.commit('SET_SUB_STATUSES', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/sub_statuses.js